import { render, staticRenderFns } from "./OrderSpending.vue?vue&type=template&id=4c262fe6&scoped=true&"
import script from "./OrderSpending.vue?vue&type=script&lang=js&"
export * from "./OrderSpending.vue?vue&type=script&lang=js&"
import style0 from "./OrderSpending.vue?vue&type=style&index=0&id=4c262fe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c262fe6",
  null
  
)

export default component.exports